import * as React from "react";
const SvgFb = (props) => /* @__PURE__ */ React.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 12.26 24.26",
	width: "1em",
	height: "1em",
	...props
}, /* @__PURE__ */ React.createElement("g", { "data-name": "Layer 2" }, /* @__PURE__ */ React.createElement("path", {
	d: "M.39 12.92h2.66v11a.39.39 0 0 0 .39.39H8a.38.38 0 0 0 .39-.39V13h3.01a.38.38 0 0 0 .39-.34l.46-4a.38.38 0 0 0-.09-.31.4.4 0 0 0-.29-.13H8.34V5.63c0-.76.41-1.14 1.22-1.14h2.31a.4.4 0 0 0 .39-.4V.39a.4.4 0 0 0-.39-.39H8.55a6.1 6.1 0 0 0-4 1.5 4.18 4.18 0 0 0-1.37 3.71v3H.39a.4.4 0 0 0-.39.34v4a.39.39 0 0 0 .39.37",
	"data-name": "Layer 1"
})));
export default SvgFb;
